<template>  
  <div>
    <v-layout>
      <v-flex md8 class="px-4">
        <h3>Ebit por año fiscal</h3>
			</v-flex>
      <v-flex md4 class="px-4">
        <!-- <template v-if="myPermissions.includes(12)">
          <v-btn color="primary" @click="redirec" class="float-r">Gestionar Años Fiscales</v-btn>
        </template> -->
			</v-flex>
    </v-layout>
    <br>
		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="filtered_items"
			class="tablaT1"
			 :class="dark_t?'dark':''">
			<template v-slot:item="props">
				<tr>
					<fs1 tag='td'>{{props.item.fiscal_year}}</fs1>
					<fs1 tag='td'>{{props.item.impacted_area_name}}</fs1>
					<fs1 tag='td'>{{props.item.value}}</fs1>
					<fs1 tag='td'>{{props.item.due_date}}</fs1>
					<fs1 tag='td' :prop="st = due_date_status(props.item)">
						<span :class="['safety-tag', due_date_status_color[st]]">{{st}}</span>
					</fs1>
				</tr>
			</template>
		</v-data-table>

  </div>	
</template>

<script>
import due_date_status from '@/components/mixins/due_date_status';

export default {
  mixins: [due_date_status],
  computed: {
		current_fiscal_year() { return (this.$store.getters.current_fiscal_year || {}).year },
		filtered_items() { return this.items.filter(f => f.fiscal_year === this.current_fiscal_year)},
		items() { return this.$store.getters.ebits },
    headers() {
      return [
				{ text: 'Año fiscal', sortable: true , value: 'fiscal_year' },
				{ text: 'Área', sortable: true , value: 'impacted_area_name' },
				{ text: 'EBITDA', sortable: true, value: 'value' },
				{ text: 'Fecha de vencimiento', sortable: true, value: 'due_date' },
				{ text: 'Estado', sortable: true, value: 'due_date' },
      ];
    },
  },
  methods: {
		redirec(){/* this.$router.push({ name: 'fiscalYears'}) */}
  },
};
</script>
